export const normEmail = (s: string | undefined | null): string =>
  (s ?? '').trim().toLowerCase();

export const normName = (s: string | undefined | null): string =>
  (s ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

export const normPhone = (s: string | undefined | null): string =>
  (s ?? '').replace(/\D/g, '').slice(-10);

export const nameKey = (first: string, last: string): string =>
  `${normName(first)}|${normName(last)}`;
